import * as d3 from 'd3'
import moment from 'moment'

export default {

  methods: {
        
    gmx_SkylineValues_Week(filterData) {
      
      if(filterData.length === 0) return

      this.timeline.week = []
      this.timeline.month = []
      this.timeline.year = []
      this.timeline.scale = null

      // set Start & End Date for the Timeline
      if(typeof this.timeline.startDate == 'number') {
        let minDate = d3.min(filterData, c => c[this.timeline.refColumn])
        let maxDate = d3.max(filterData, c => c[this.timeline.refColumn])

        this.timeline.startDate = moment(minDate).add(-(this.timeline.startDate*7), 'days').toDate()
        this.timeline.endDate = moment(maxDate).add(this.timeline.endDate*7, 'days').toDate()
      } else if(typeof this.timeline.startDate == 'string') {
        this.timeline.startDate = moment(this.timeline.startDate).toDate()
        this.timeline.endDate = moment(this.timeline.endDate).toDate()
      }
      
      let sDate_ = moment(this.timeline.startDate).toDate()
      let eDate_ = moment(moment(this.timeline.endDate).format('YYYY-MM-DD 23:59:59')).toDate()

      let weekNames = ['sunday', 'monday', 'tuesday', 'wednesday ', 'thursday', 'friday', 'saturday']
      let cutoff_Week = weekNames.findIndex(n_ => n_ == this.timeline.weekEnd)

      let diff_ = cutoff_Week - sDate_.getDay()
      sDate_ = moment(sDate_).add(diff_ < 0 ? 7 + diff_ : diff_, 'days').toDate()

      diff_ = cutoff_Week - eDate_.getDay()
      eDate_ = moment(eDate_).add(diff_ < 0 ? 7 + diff_ : diff_, 'days').toDate()


      // ### Set Timeline-Values for the Week ###
      let nextDate = moment(moment(sDate_).format('YYYY-MM-DD 23:59:59')).toDate()
      while(nextDate <= eDate_) {
        let value_ = {
          sDate: moment(moment(nextDate).add(-6, 'days').format('YYYY-MM-DD')).toDate(),
          mDate: null,
          eDate: nextDate,
          date: moment(nextDate).format('YYYY-MM-DD')
        }
        value_.mDate = new Date(d3.mean([value_.sDate, value_.eDate]))
        
        this.timeline.week.push({ name: value_.eDate.getDate(), ...value_ })
        nextDate = moment(nextDate).add(7, 'days').toDate()
      }
      
      // ### Set Timeline-Values for the Month ###
      eDate_ = null
      let months_ = []
      let months__ = []
      this.timeline.week.forEach((w_, i) => {
        if(eDate_ != d3.timeFormat('%Y-%m')(w_.eDate)) {
          eDate_ = d3.timeFormat('%Y-%m')(w_.eDate)

          if(i > 0) {
            months_.push(months__)
            months__ = []
          }
        }
        months__.push(w_)
        if(i === this.timeline.week.length - 1) months_.push(months__)
      })
      months_.forEach(m_ => {
        this.timeline.month.push({
          name: d3.timeFormat('%b')(m_[0].eDate), 
          sDate: m_[0].sDate, 
          mDate: new Date(d3.mean([ m_[0].sDate, m_[m_.length - 1].eDate ])),
          eDate: m_[m_.length - 1].eDate
        })
      })

      // ### Set Timeline-Values for the Year ###
      eDate_ = null
      let years_ = []
      let years__ = []
      this.timeline.week.forEach((w_, i) => {
        if(eDate_ != d3.timeFormat('%Y')(w_.eDate)) {
          eDate_ = d3.timeFormat('%Y')(w_.eDate)

          if(i > 0) {
            years_.push(years__)
            years__ = []
          }
        }
        years__.push(w_)
        if(i === this.timeline.week.length - 1) years_.push(years__)
      })
      years_.forEach(m_ => {
        this.timeline.year.push({
          name: d3.timeFormat('%Y')(m_[m_.length - 1].eDate), 
          sDate: m_[0].sDate, 
          mDate: new Date(d3.mean([ m_[0].sDate, m_[m_.length - 1].eDate ])),
          eDate: m_[m_.length - 1].eDate
        })
      })

      // ### Set necessary ENV-Values for the Skyline ### -------------------
      this.timeline.length = this.timeline.week.length * (this.skyline.width + (this.skyline.gap * 2))
      this.timeline.weekSize = this.skyline.width + (this.skyline.gap * 2)
   
      // get min & max values of the timeline-scale
      this.timeline.scale = d3.scaleTime()
      .domain([
        this.timeline.week[0].sDate, 
        this.timeline.week[this.timeline.week.length - 1].eDate
      ])
      .rangeRound([0, this.timeline.length])
    },


    gmx_SkylineValues_Month(filterData) {
          
      if(filterData.length === 0) return

      this.timeline.month = []
      this.timeline.year = []
      this.timeline.scale = null

       // set Start & End Date for the Timeline
      if(typeof this.timeline.startDate == 'number') {
        let minDate = d3.min(filterData, c => c[this.timeline.refColumn])
        let maxDate = d3.max(filterData, c => c[this.timeline.refColumn])

        this.timeline.startDate = moment(minDate).add(-(this.timeline.startDate), 'month').toDate()
        this.timeline.endDate = moment(maxDate).add(this.timeline.endDate, 'month').toDate()
      } else if(typeof this.timeline.startDate == 'string') {
        this.timeline.startDate = moment(this.timeline.startDate).toDate()
        this.timeline.endDate = moment(this.timeline.endDate).toDate()
      }

      let sDate_ = moment(this.timeline.startDate).startOf('month').toDate()
      let eDate_ = moment(moment(this.timeline.endDate).format('YYYY-MM-DD 23:59:59')).toDate()

      let nextMonth = sDate_

      while(nextMonth <= eDate_) {
        let value_ = {
          name: d3.timeFormat('%b')(nextMonth), 
          sDate: nextMonth,
          mDate: null,
          eDate: moment(moment(nextMonth).endOf('month').format('YYYY-MM-DD 23:59:59')).toDate(),
          date: moment(nextMonth).format('YYYY-MM-DD')
        }
        value_.mDate = new Date(d3.mean([value_.sDate, value_.eDate]))
        
        this.timeline.month.push({ name: '', ...value_ })
        nextMonth = moment(nextMonth).add(1, 'months').toDate()
      }
      
      // ### Set Timeline-Values for the Year 
      eDate_ = null
      let years_ = []
      let years__ = []

      this.timeline.month.forEach((m_, i) => {
        if(eDate_ != d3.timeFormat('%Y')(m_.eDate)) {
          eDate_ = d3.timeFormat('%Y')(m_.eDate)
          if(i > 0) {
            years_.push(years__)
            years__ = []
          }
        }
        years__.push(m_)
        if(i === this.timeline.month.length - 1) years_.push(years__)
      })

      years_.forEach(m_ => {
        this.timeline.year.push({
          name: d3.timeFormat('%Y')(m_[m_.length - 1].eDate), 
          sDate: m_[0].sDate, 
          mDate: new Date(d3.mean([ m_[0].sDate, m_[m_.length - 1].eDate ])),
          eDate: m_[m_.length - 1].eDate
        })
      })
      
      // get min & max values of the timeline-scale
      this.timeline.length = this.timeline.month.length * (this.skyline.width + (this.skyline.gap * 2))
      this.timeline.scale = d3.scaleTime()
      .domain([
        this.timeline.month[0].sDate, 
        this.timeline.month[this.timeline.month.length - 1].eDate
      ])
      .rangeRound([0, this.timeline.length])

    },


    gmx_setTimelineCDate(date, type) {

      if(type == null) type = 'week'; else type = 'month'

      let date_ = moment(date).toDate()

      if (type == 'month') {
        if (this.JQueries && this.JQueries.weekend) {
          let week_ = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']

          let d = moment(date).toDate()
          let currentDay = d.getDay()
          let targetDay = week_.indexOf(this.JQueries.weekend.toLowerCase())

          if (currentDay !== targetDay) {
            let daysToAdd = (7 + targetDay - currentDay) % 7
            d.setDate(d.getDate() + daysToAdd)
            date_ = d
          } 
        }
      }

      let cdate = this.timeline[type].find(f => date_ >= f.sDate && date_ <= f.eDate)

      return cdate ? cdate : null
    },


    
    























  }

}